export default __webpack_public_path__ + "images/CU.47f951b.png";